import { Component, Inject, Input, OnInit } from '@angular/core';
import { MatDialogRef, MAT_DIALOG_DATA } from '@angular/material/dialog';
import { AppStateService } from '../app-state.service';
import { TranslateService } from '@ngx-translate/core';
import { ZaverecnaPraca } from '../model/zaverecna-praca';

export interface ZaverecnePraceDialogData {
  pocetBakalarskychPrac: number;
  pocetDiplomovychPrac: number;
  pocetDizertacnychPrac: number;
  idTypZaznamu: number;
}

@Component({
  selector: 'app-zaverecne-prace-dialog',
  standalone: false,
  templateUrl: './zaverecne-prace-dialog.component.html',
  styleUrl: './zaverecne-prace-dialog.component.css'
})
export class ZaverecnePraceDialogComponent implements OnInit {

  spinner = false;

  zaverecnePrace: ZaverecnaPraca[] = [];

  typyZaverecnychPracMap: Map<number, string> = new Map();
  typyZaverecnychPracAIchPocetMap: Map<number, number> = new Map();

  typyZaverecnychPracAZoznamPracDanehoTypuMap: Map<number, ZaverecnaPraca[]> = new Map();

  pocetBakalarskychPrac: number = 0;
  pocetDiplomovychPrac: number = 0;
  pocetDizertacnychPrac: number = 0;

  typZobrazovanychDat: string;
  typPrace: number;

  readonly ID_TYP_POCET_AKTUALNE_VEDENYCH_PRAC = -60;
  readonly ID_TYP_POCET_OBHAJENYCH_PRAC = -64;
  readonly ID_TYP_POCET_OBHAJENYCH_PRAC_BAKALARSKYCH = -110;
  readonly ID_TYP_POCET_OBHAJENYCH_PRAC_DIPLOMOVYCH = -114;
  readonly ID_TYP_POCET_OBHAJENYCH_PRAC_DIZERTACNYCH = -118;

  readonly ZOZNAM_ID_TYPOV_OBHAJENYCH_PRAC = [
        this.ID_TYP_POCET_OBHAJENYCH_PRAC,
        this.ID_TYP_POCET_OBHAJENYCH_PRAC_BAKALARSKYCH,
        this.ID_TYP_POCET_OBHAJENYCH_PRAC_DIPLOMOVYCH,
        this.ID_TYP_POCET_OBHAJENYCH_PRAC_DIZERTACNYCH
    ];


  // readonly TYP_BAKALARSKA_PRACA = 'bakalárska';
  // readonly TYP_DIPLOMOVA_PRACA = 'magisterská/inžinierska';
  // readonly TYP_DIZERTACNA_PRACA = 'dizertačná';

  readonly TYP_BAKALARSKA_PRACA = 1;
  readonly TYP_DIPLOMOVA_PRACA = 2;
  readonly TYP_DIZERTACNA_PRACA = 3;


  constructor(public appStateService: AppStateService,
    public dialogRef: MatDialogRef<ZaverecnePraceDialogComponent>,
    @Inject(MAT_DIALOG_DATA) public dataMatDialog: ZaverecnePraceDialogData,
    private translateService: TranslateService) {
  }

  ngOnInit(): void {


    const idTyp = this.dataMatDialog.idTypZaznamu;
    this.typZobrazovanychDat = this.getTypZobrazovanychDat(idTyp);
    this.typPrace = this.getTypPrace(idTyp);

    //  ak existuje this.typPrace, tak sa na dialogu zobrazi iba jeden typ zaverecnej prace,
    // ktory je urceny hodnotou this.typPrace
    if (this.typPrace) {

      let popisTypuPrace = '';

      switch (this.typPrace) {

        case this.TYP_BAKALARSKA_PRACA:

          popisTypuPrace = this.translateService.instant('Bakalárske (prvý stupeň)');

          break;

        case this.TYP_DIPLOMOVA_PRACA:

          popisTypuPrace = this.translateService.instant('Diplomové (druhý stupeň)');

          break;

        case this.TYP_DIZERTACNA_PRACA:

          popisTypuPrace = this.translateService.instant('Dizertačné (tretí stupeň)');

          break;

        default:
          break;
      }

      this.typyZaverecnychPracMap.set(this.typPrace, popisTypuPrace);

    } else {

      this.typyZaverecnychPracMap.set(this.TYP_BAKALARSKA_PRACA,
        this.translateService.instant('Bakalárske (prvý stupeň)'));
      this.typyZaverecnychPracMap.set(this.TYP_DIPLOMOVA_PRACA,
        this.translateService.instant('Diplomové (druhý stupeň)'));
      this.typyZaverecnychPracMap.set(this.TYP_DIZERTACNA_PRACA,
        this.translateService.instant('Dizertačné (tretí stupeň)'));

    }

    this.appStateService.zaverecnePraceDataFetched
      .subscribe((data: ZaverecnaPraca[]) => {

      this.zaverecnePrace = data;

      this.typyZaverecnychPracAIchPocetMap.clear();
      this.typyZaverecnychPracAZoznamPracDanehoTypuMap.clear();

      for (let zp of this.zaverecnePrace) {

        if  (!this.typyZaverecnychPracAIchPocetMap.get(zp.typPraceId)) {

          this.typyZaverecnychPracAIchPocetMap.set(zp.typPraceId, 1);

        } else {

          this.typyZaverecnychPracAIchPocetMap.set(zp.typPraceId,
            this.typyZaverecnychPracAIchPocetMap.get(zp.typPraceId) + 1);

        }

        if (!this.typyZaverecnychPracAZoznamPracDanehoTypuMap.get(zp.typPraceId)) {
          this.typyZaverecnychPracAZoznamPracDanehoTypuMap.set(zp.typPraceId, [zp]);
        } else {
          this.typyZaverecnychPracAZoznamPracDanehoTypuMap.get(zp.typPraceId).push(zp);
        }

      }

    });


    this.appStateService.fetchZaverecnePraceData(this.typZobrazovanychDat);

  }

	getTitle() {

    let result = '';
		if (this.typZobrazovanychDat === this.appStateService.ZAVERECNE_PRACE_VEDENE) {
      result = this.translateService.instant('Vedené záverečné práce evidované v AiS2');
    } else {
      result = this.translateService.instant('Obhájené záverečné práce evidované v AiS2');
    }

    return result;
	}

    potvrditVyberZP() {

        const data = {
            pocetBakalarskychPrac: this.typyZaverecnychPracAIchPocetMap.get(this.TYP_BAKALARSKA_PRACA) || 0,
            pocetDiplomovychPrac: this.typyZaverecnychPracAIchPocetMap.get(this.TYP_DIPLOMOVA_PRACA) || 0,
            pocetDizertacnychPrac: this.typyZaverecnychPracAIchPocetMap.get(this.TYP_DIZERTACNA_PRACA) || 0
        };

        this.dialogRef.close(data);

    }

    getTypTemy() {

    }

  getPocetPracTypu(typ: number) {
    return this.typyZaverecnychPracAIchPocetMap.get(typ) || 0;
  }

  getTypZobrazovanychDat(idTyp: number) : string {

    //TODO: skusam
    // return this.appStateService.ZAVERECNE_PRACE_OBHAJENE;


    if (idTyp === this.ID_TYP_POCET_AKTUALNE_VEDENYCH_PRAC) {
        return this.appStateService.ZAVERECNE_PRACE_VEDENE;
    } else if (this.ZOZNAM_ID_TYPOV_OBHAJENYCH_PRAC.includes(idTyp)) {
        return this.appStateService.ZAVERECNE_PRACE_OBHAJENE;
    }

    return '';

  }

  getTypPrace(idTypZaznamu: number) : number {

    if (idTypZaznamu === this.ID_TYP_POCET_OBHAJENYCH_PRAC_BAKALARSKYCH) {
      return this.TYP_BAKALARSKA_PRACA;
    }

    if (idTypZaznamu === this.ID_TYP_POCET_OBHAJENYCH_PRAC_DIPLOMOVYCH) {
      return this.TYP_DIPLOMOVA_PRACA;
    }

    if (idTypZaznamu === this.ID_TYP_POCET_OBHAJENYCH_PRAC_DIZERTACNYCH) {
      return this.TYP_DIZERTACNA_PRACA;
    }

    return 0;
  }



}
